import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import Button from "@/components/wpl/button/src";
import { Picture } from "@/components/wpl/image/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

const bannerStyle = css({
    "backgroundImage":
        "linear-gradient(131deg, #0052CC 38.54%, #2684FF 84.19%)",
    "display": "grid",
    "gridTemplateColumns": "1fr",
    "placeItems": "center",
    "gap": "1rem",
    "maxWidth": "100%",
    "padding": "2rem",
    "margin": "-4rem 0 0",
    "transform": "translateY(4rem)",

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".jpd-screenshot": {
        display: "none",
        marginBlockStart: "1rem",
        alignSelf: "flex-end"
    },

    [media.above.md]: {
        width: "100%",
        gridTemplateColumns: "max-content 1fr 1.9fr max-content"
    },
    [media.only.sm]: {
        gridTemplateColumns: "max-content 1fr 1fr",
        padding: "1rem 2rem"
    },
    [media.below.md]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".jpd-screenshot": {
            display: "none"
        }
    },
    [media.above.md]: {
        "padding": "0rem 2rem 0rem",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".jpd-screenshot": {
            display: "initial"
        }
    }
});

const textStyle = css({
    color: "#ffffff",
    letterSpacing: ".3px",
    fontWeight: 500,
    textAlign: "center",
    marginBlockStart: 0,
    fontSize: "1.5rem",
    lineHeight: 1.25,

    [media.above.sm]: {
        marginBlock: 0,
        textAlign: "left",
        paddingBlock: "1rem"
    }
});

const RegistrationBanner = () => {
    const intl = useIntl();

    return (
        <Row layout="12">
            <div css={bannerStyle}>
                <Picture
                    image={{
                        src: "https://wac-cdn.atlassian.com/dam/jcr:275dd3a8-77b5-4f65-85fe-1e8d8bc1f624/jpd-pt-hexigon-circle.svg",
                        alt: " ",
                        loading: "lazy",
                        width: 73,
                        height: 73
                    }}
                />
                <h3 css={textStyle}>
                    {intl.formatMessage({
                        id: "JiraProductDiscoveryPage.demo.bodyText",
                        defaultMessage: "Join our demo with live chat Q&A"
                    })}
                </h3>
                <Picture
                    image={{
                        className: "jpd-screenshot",
                        src: "https://wac-cdn.atlassian.com/dam/jcr:58455588-41f6-4fc5-948e-321b8dea4a79/jpd-pt-product-shot.svg",
                        alt: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.demo.screenshotAlt",
                            defaultMessage:
                                "Screenshot of Jira Product Discovery"
                        }),
                        loading: "lazy",
                        width: 469,
                        height: 114
                    }}
                />
                <Button
                    text={intl.formatMessage({
                        id: "JiraProductDiscoveryPage.demo.ctaText",
                        defaultMessage: "Register now"
                    })}
                    color="yellow"
                    url={useLocalizedHref(
                        "/software/jira/product-discovery/demo"
                    )}
                    dataEventProps={{
                        "data-event": "clicked",
                        "data-event-container": "banner-link-button",
                        "data-event-component": "linkButton",
                        "data-product-key": "jiraProductDiscovery"
                    }}
                />
            </div>
        </Row>
    );
};

export default RegistrationBanner;
